<template>
  <div id="map-container" ref="myEchart"></div>
</template>

<script>
// import echarts from "echarts";
import * as echarts from "echarts";
import "./china.js"; // 引入中国地图数据

export default {
  props: {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  computed: {},
  watch: {},
  methods: {
    initChart() {
      console.log(echarts);
      this.myEchart = echarts.init(this.$refs.myEchart);
      let option = {
        tooltip: {
          show: false,
        },
        geo: {
          map: "china",
          roam: false, // 一定要关闭拖拽
          zoom: 1.23,
          center: [105, 36], // 调整地图位置
          label: {
            normal: {
              show: false, //关闭省份名展示
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#8697B7",
              borderColor: "#8697B7",
              borderWidth: 1, //设置外层边框
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0,
              shadowColor: "#01012a",
            },
            emphasis: {
              areaColor: "#184cff",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 5,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            type: "map",
            map: "china",
            roam: false,
            zoom: 1.23,
            center: [105, 36],
            // geoIndex: 1,
            // aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#8697B7",
                borderColor: "#0C2F6F",
                borderWidth: 0.8,
              },
              emphasis: {
                areaColor: "#1A4E9E",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 5,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.myEchart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
#map-container {
  width: 60vw !important;
  height: 60vh !important;
  margin: 0 auto;
  canvas{
	 width: 60vw !important;
	 height: 60vh !important; 
  }
}
</style>
